import { useEffect, useState } from "react";
import { getAllTypes } from "../services/api";

export default function useTypes() {
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    getAllTypes().then((data) => {
      setCategories(data);
    });
  }, []);

  return categories;
}
